import { render } from "./HandballNetBanner.vue?vue&type=template&id=5d66d2aa&scoped=true"
import script from "./HandballNetBanner.vue?vue&type=script&lang=js"
export * from "./HandballNetBanner.vue?vue&type=script&lang=js"

import "./HandballNetBanner.vue?vue&type=style&index=0&id=5d66d2aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d66d2aa"]])

export default __exports__